import iconHome from '../../../assets/icons/home.svg'

const DefaultStore = {
    showMenu: false,
    activeItem: 0,
    items: [
        {
            text: "Dashboard",
            icon: iconHome,
            subItems: []
        },
        {
            text: "Content",
            icon: iconHome,
            subItems: [
                {
                    url: "/content/pages",
                    text: "Pages"
                }
            ]
        },
    ]
}

export default DefaultStore
